import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/email-templates"

export const List = async (values) => {
    return await axiosInstance(options).get(`${path}/list${objToURL(values)}`);
}

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}`, values);
} 

export const Edit = async (values,id) => {
    return await axiosInstance(options).put(`${path}/${id}`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).delete(`${path}/${values}`)
}

export const Details  = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}`);
}

export const Status = async (values) => {
    return await axiosInstance(options).post(`${path}/change-status`, values)
}

export const Options = async (values) => {
    return await axiosInstance(options).post(`${path}/options`, values)
}

export const TestEmail = async (values) => {
    return await axiosInstance(options).post(`${path}/send-test-email`, values)
}

export const Layout = async () => {
    return await axiosInstance(options).get(`${path}/layout`);
}


